import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

import styles from './BuyXPayForYChip.module.scss'

export interface PopularChipProps extends ChipProps{
  x: number
  y: number
}

export const BuyXPayForYChip: FC<PopularChipProps> = ({ x, y }) => {
  const { t } = useTranslation()
  return (
    <Chip backgroundColor="var(--green-300)" className={styles.buyXPayForYChip} size="small" textColor="var(--white)">
      {
        t('common:BUY_3_PAY_FOR_2_PRODUCT_PAGE_IMAGE_TAG', 'Buy 3 pay for 2').replace(/\b(3|2)\b/g, match => (match === '3' ? `${x}` : `${y}`))
      }
    </Chip>
  )
}

